import Exceed from '@txdfe/at-exceed';
import apimap from './apimap';
// 对apimap做一次封装，最简只需定义id和url字段
function apimapCreator(apimapArr) {
    // 在这里可以对请求做一些统一处理，如加前缀、加headers
    return apimapArr.map(option => Object.assign(option, {
        name: option.name || option.id,
        id: option.id,
        method: option.method || 'get',
        contentType: option.type || 'application/x-www-form-urlencoded',
        urls: {
            local: `${window.UILessConfig.host}${option.url}`,
        },
    }));
}
const exceed = new Exceed({
    ENV: 'local',
});
exceed.use(apimapCreator(apimap));
exceed.interceptors.response.use((response) => {
    response.status = parseInt(response.headers['x-http-status'] || response.status);
    const code = parseInt(response.data.code);
    if (code > 300 || code < 200) {
        return Promise.reject(response);
    }
    return Promise.resolve(response);
}, (error) => {
    return Promise.reject(error);
});
export default exceed;
